var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { map, retry } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LocalService } from './local.service';
import { SessionService } from './session.service';
import { GPT_FEATURE } from '../utilities/featureFlags';
import * as i0 from "@angular/core";
import * as i1 from "./session.service";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/router";
import * as i4 from "./local.service";
var AuthService = /** @class */ (function () {
    function AuthService(sessionService, http, router, localService) {
        this.sessionService = sessionService;
        this.http = http;
        this.router = router;
        this.localService = localService;
        this.URL = environment.baseServerURL + "/auth";
        this.featureFlagsRequests = new Map();
        this.tokenExp = 0;
        this.currentUserSubject = new BehaviorSubject(this.localService.getJsonValue('userData'));
        this.retrieveUser();
    }
    Object.defineProperty(AuthService.prototype, "currentUserValue", {
        get: function () {
            return this.currentUserSubject.value;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.login = function (email, password) {
        var _this = this;
        return this.http.post(this.URL + "/login", {
            username: email,
            password: password
        }, {
            withCredentials: true
        }).pipe(map(function (user) {
            _this.tokenExp = 0;
            _this.currentUserSubject.next(user);
            return user;
        }));
    };
    AuthService.prototype.validateSession = function () {
        return this.http.post(this.URL + "/check", {}, {
            withCredentials: true,
        }).pipe(map(function (validate) {
            return validate;
        }));
    };
    AuthService.prototype.logout = function () {
        var _this = this;
        if (this.user.role.id === 5) {
            this.sessionService.setOffline.emit(this.user);
        }
        else {
            setTimeout(function () {
                _this.http.post(_this.URL + "/logout", {}, {
                    withCredentials: true
                }).subscribe(function (_) {
                    _this.localService.removeJsonValue('featureFlags');
                    _this.localService.removeJsonValue('userData');
                    _this.localService.removeJsonValue('messages');
                    _this.localService.removeJsonValue('sessionId');
                    _this.localService.removeJsonValue('superAdminCompany');
                    sessionStorage.clear();
                    _this.user = {};
                    _this.router.navigate(['/login']);
                    window.location.reload();
                }, function (error) {
                    console.error(error);
                });
            }, 100);
        }
    };
    AuthService.prototype.sendRecoverEmail = function (emailAddress) {
        return this.http.post(this.URL + "/recoveryPassword", {
            email: emailAddress
        });
    };
    AuthService.prototype.checkRecoveryToken = function (token) {
        return this.http.post(this.URL + "/checkToken", {
            token: token
        });
    };
    AuthService.prototype.resetPassword = function (email, password, token) {
        return this.http.post(this.URL + "/resetPassword", {
            email: email,
            password: password,
            token: token
        });
    };
    AuthService.prototype.changeCompany = function (company) {
        this.sessionService.changeCompany.emit(company.id);
        this.user.company = company;
        this.user.bot = company.bots[0];
        sessionStorage.clear();
        this.persistUser(this.user);
    };
    AuthService.prototype.persistUser = function (userData) {
        this.user = userData;
        this.localService.setJsonValue('userData', userData);
        if (this.user.role.name === 'superadmin') {
            this.superAdminCompany = this.user.company;
        }
        this.localService.setJsonValue('superAdminCompany', this.superAdminCompany);
    };
    AuthService.prototype.updateToken = function (token, exp) {
        var current = this.currentUserSubject.value;
        if (!token || !current || !current.token || current.token === token) {
            return false;
        }
        if (exp * 1000 <= Date.now()) {
            return false;
        }
        // A header replayed from an HTTP cache carries an exp older than the token already
        // in use; compare against the current token's own exp, not just the in-memory
        // tokenExp, since that gets reset to 0 on login/reload.
        var currentTokenExp = this.decodeJwtExp(current.token);
        if (currentTokenExp !== null) {
            if (exp <= currentTokenExp) {
                return false;
            }
        }
        else if (this.tokenExp && exp <= this.tokenExp) {
            return false;
        }
        this.tokenExp = exp;
        var updated = __assign({}, current, { token: token });
        this.currentUserSubject.next(updated);
        if (this.user && typeof this.user === 'object') {
            this.user.token = token;
        }
        var stored = this.localService.getJsonValue('userData');
        if (stored && typeof stored === 'object') {
            this.localService.setJsonValue('userData', __assign({}, stored, { token: token }));
        }
        return true;
    };
    AuthService.prototype.decodeJwtExp = function (token) {
        try {
            var payloadSegment = token.split('.')[1];
            if (!payloadSegment) {
                return null;
            }
            var base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
            var payload = JSON.parse(atob(base64));
            return typeof payload.exp === 'number' ? payload.exp : null;
        }
        catch (_a) {
            return null;
        }
    };
    AuthService.prototype.retrieveUser = function () {
        var storedData = this.localService.getJsonValue('userData');
        storedData = storedData != null ? storedData : '{}';
        this.user = storedData;
    };
    AuthService.prototype.getUser = function () {
        return this.localService.getJsonValue('userData');
    };
    AuthService.prototype.restoreSuperAdminCompany = function () {
        this.user.company = this.superAdminCompany;
        this.localService.setJsonValue('userData', this.user);
    };
    AuthService.prototype.getFeatureFlagsByCompany = function () {
        var URL = environment.baseServerURL + "/security/featureFlags/" + this.user.company.id;
        return this.http.get(URL, {
            withCredentials: true
        });
    };
    AuthService.prototype.getFeatureFlags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var companyId, pendingRequest, request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        companyId = Number(this.user && this.user.company && this.user.company.id);
                        pendingRequest = this.featureFlagsRequests.get(companyId);
                        if (pendingRequest) {
                            return [2 /*return*/, pendingRequest];
                        }
                        request = this.loadFeatureFlags(companyId);
                        this.featureFlagsRequests.set(companyId, request);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, request];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        this.featureFlagsRequests.delete(companyId);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.loadFeatureFlags = function (companyId) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedFeatureFlags, featureFlags, normalizedFeatureFlags, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedFeatureFlags = this.getCachedFeatureFlags(companyId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getFeatureFlagsByCompany()
                                .pipe(retry(2))
                                .toPromise()];
                    case 2:
                        featureFlags = _a.sent();
                        normalizedFeatureFlags = this.ensureConfiguredTechnologyFlags(Array.isArray(featureFlags) ? featureFlags : []);
                        this.cacheFeatureFlags(companyId, normalizedFeatureFlags);
                        return [2 /*return*/, normalizedFeatureFlags];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error fetching feature flags:', error_1);
                        return [2 /*return*/, this.ensureConfiguredTechnologyFlags(cachedFeatureFlags)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.getCachedFeatureFlags = function (companyId) {
        var featureFlagsByCompany = this.localService.getJsonValue('featureFlags');
        if (!featureFlagsByCompany || typeof featureFlagsByCompany !== 'object') {
            return [];
        }
        var featureFlags = featureFlagsByCompany[companyId];
        return Array.isArray(featureFlags) ? featureFlags : [];
    };
    AuthService.prototype.cacheFeatureFlags = function (companyId, featureFlags) {
        var storedFeatureFlags = this.localService.getJsonValue('featureFlags');
        var featureFlagsByCompany = storedFeatureFlags && typeof storedFeatureFlags === 'object'
            ? storedFeatureFlags
            : {};
        featureFlagsByCompany[companyId] = featureFlags;
        this.localService.setJsonValue('featureFlags', featureFlagsByCompany);
    };
    AuthService.prototype.ensureConfiguredTechnologyFlags = function (featureFlags) {
        var technologyType = Number(this.user && this.user.bot && this.user.bot.technologyType);
        var botUsesGpt = technologyType === 2 || technologyType === 3 || technologyType === 4 || technologyType === 5;
        if (!botUsesGpt || featureFlags.includes(GPT_FEATURE)) {
            return featureFlags;
        }
        return featureFlags.concat(GPT_FEATURE);
    };
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.SessionService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.LocalService)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
